<template>
  <div class="event-modal" v-exposure="{ eid: `119_0_0_0` }" :data-id="`119_0_0_0`">
    <el-carousel
      :class="['event-lunbo', hiddenDot ? 'hidden-dot' : '']"
      ref="slideCarousel"
      :autoplay="false"
      indicator-position="outside"
      arrow="never"
      trigger="click"
    >
      <el-carousel-item v-for="item in list" :key="item.sid">
        <!-- x显示文本公告 -->
        <div style="height: 53vh; overflow-y: auto">
          <div class="title">{{ item.languages?.title || "" }}</div>
          <div class="system-time">{{ getShowStartTime(item.showStartTime) }}</div>
          <div class="swiper-content" v-html="changeTarget(item.languages?.content || '')"></div>
          <div class="btns">
            <el-button
              v-if="item.jump?.type && item.languages?.buttonText"
              v-exposure="{ eid: `119_0_0_119002` }"
              :data-id="`119_0_0_119002`"
              class="btn1"
              size="medium"
              @click="clickFun(item)"
            >
              {{ item.languages?.buttonText }}
            </el-button>
            <!-- <el-button
              v-if="!taken"
              v-exposure="{ eid: `119_0_0_119001` }"
              :data-id="`119_0_0_119001`"
              class="btn2"
              size="medium"
              @click="onGoRegister"
            >
              {{ $t("Datalang.HomePage_BTM_register") }}
              <img class="icon" :src="require(`@/lobby_common/assets/activity/gif.png`)" alt="" srcset="" />
            </el-button> -->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import eventsModal from "@/lobby_common/mixins_components/eventsModal/index.js";
export default {
  components: {},
  props: [],
  mixins: [eventsModal],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.event-modal {
  max-height: 600px;
  @media (max-width: 768px) {
    max-height: 450px;
  }
}
.event-lunbo {
  &.hidden-dot {
    .el-carousel__indicators {
      display: none;
    }
  }
  .el-carousel__indicators {
    .el-carousel__button {
      height: 5px;
      border-radius: 2px;
    }
  }

  .el-carousel__container {
    min-height: 450px;
    height: auto;
    @media (max-width: 768px) {
      min-height: 400px;
    }
    .el-carousel__item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .title {
      font-size: 17px;
      line-height: 30px;

      span {
        font-size: 12px;
      }
    }

    .img_content {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .btns {
      text-align: center;
      bottom: 8%;
      width: 100%;
      position: absolute;
      .btn1 {
        background: var(--button-100);
        color: var(--font-color-1300);
      }
      .btn2 {
        background: var(--button-200);
        color: var(--font-color-1400);
        position: relative;
        .icon {
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-20px);
          height: 40px;
        }
      }
      .el-button {
        border: none;
        &:hover {
          opacity: 1 !important;
        }
      }
    }

    .system-time {
      padding: 10px 0;
      font-size: 14px;
      padding-left: 15px;
      color: var(--font-color-600);
    }

    .swiper-content {
      font-size: 15px;
      white-space: break-spaces;
      word-break: break-word;
      hyphens: none;
      line-height: 24px;
      color: var(--font-color-900);
      p {
        margin: 0;
        line-height: 24px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>
